module.exports = {
  borderRadiusSmall: "4px",
};